import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Select from "react-select";

const SiteSettings = () => {
  const token = localStorage.getItem("token");
  const [form, setForm] = useState({});
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("info");
  const [activeTab, setActiveTab] = useState("default");
  const [excelHeaders, setExcelHeaders] = useState([]);

  const invoiceFields = [
    { key: "default_invoiceReturnPercent", label: "% повернення з фактури", suffix: "%", step: "0.01", min: 0, max: 100 },
    { key: "default_invoiceProcessingPrice", label: "Стандартна ціна за обробку фактури", suffix: " zł", step: "0.01", min: 0 },
  ];

  const boltKeys = [
    "driver_fullName",
    "incBrutto",
    "incBruttoApp",
    "incBruttoCash",
    "incNettoCash",
    "tips",
    "appFee",
    "incNetto",
    "totalInc",
    "bonus"
  ];

  const uberKeys = [
    "driver_firstName",
    "driver_lastName",
    "incNetto",
    "incBrutto",
    "appFee",
    "appFeeTaxes",
    "tips",
    "incCash",
    "bonus"
  ];

  const freenowKeys = [
    "driver_fullName",   // новий для налаштування розділення імені
    "cash",
    "brutto",
    "saldo_freenow",
    "bonus",
    "tips"
  ];



  const areAllBoltFieldsFilled = boltKeys.every(
    (key) => form[`bolt_${key}`]?.trim?.() !== ""
  );
  const allBoltFieldsMatchHeaders = boltKeys.every(
    (key) => excelHeaders.includes(form[`bolt_${key}`])
  );

  const areAllUberFieldsFilled = uberKeys?.every(
    (key) => form[`uber_${key}`]?.trim?.() !== ""
  );
  const allUberFieldsMatchHeaders = uberKeys?.every(
    (key) => excelHeaders.includes(form[`uber_${key}`])
  );

  const areAllFreeNowFieldsFilled = freenowKeys?.every(
    (key) => form[`freenow_${key}`]?.trim?.() !== ""
  );
  const allFreeNowFieldsMatchHeaders = freenowKeys?.every(
    (key) => excelHeaders.includes(form[`freenow_${key}`])
  );


  const handleClearBoltFields = () => {
    const cleared = {};
    boltKeys.forEach((key) => {
      cleared[`bolt_${key}`] = "";
    });
    setForm((prev) => ({ ...prev, ...cleared }));
  };


  useEffect(() => {
    axios
      .get("/api/settings", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data || {};
        setForm({
          ...data,
          default_invoiceReturnPercent: data.default_invoiceReturnPercent != null ? data.default_invoiceReturnPercent : "",
          default_invoiceProcessingPrice: data.default_invoiceProcessingPrice != null ? data.default_invoiceProcessingPrice : "",
        });
      })
      .catch(() => {
        setMessage("Помилка завантаження налаштувань");
        setMessageType("danger");
      });
  }, []);

  const addCustomOption = (value) => {
    if (!excelHeaders.includes(value)) {
      setExcelHeaders((prev) => [...prev, value]);
    }
  };

  const handleSave = () => {
    axios
      .post("/api/settings", form, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        setMessage("Налаштування успішно збережено ✅");
        setMessageType("success");
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          setMessage("У вас немає доступу ❌");
        } else {
          setMessage("Помилка збереження ❌");
        }
        setMessageType("danger");
      });
  };

  return (
    <div className="container py-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h3 className="card-title mb-4">Налаштування сайту</h3>

          <ul className="nav nav-tabs mb-4">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "default" ? "active" : ""}`}
                onClick={() => setActiveTab("default")}
              >
                Значення за замовчуванням
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "uber" ? "active" : ""}`}
                onClick={() => setActiveTab("uber")}
              >
                Налаштування полів Uber
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "bolt" ? "active" : ""}`}
                onClick={() => setActiveTab("bolt")}
              >
                Налаштування полів Bolt
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "freenow" ? "active" : ""}`}
                onClick={() => setActiveTab("freenow")}
              >
                Налаштування полів FreeNow
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "months" ? "active" : ""}`}
                onClick={() => setActiveTab("months")}
              >
                Мапінг тижнів
              </button>
            </li>
          </ul>
          {message && (
            <div className={`alert alert-${messageType} mt-4`} role="alert">
              {message}
            </div>
          )}
          {activeTab === "default" && (
            <div className="default-tab">
              <div className="mb-3 p-3 rounded bg-light border">
                <h6 className="text-muted mb-3 small text-uppercase">Фактура</h6>
                <div className="row g-3">
                  {invoiceFields.map(({ key, label, suffix, step, min, max }) => (
                    <div className="col-md-6" key={key}>
                      <label htmlFor={key} className="form-label small mb-1">{label}</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="number"
                          className="form-control"
                          id={key}
                          min={min}
                          max={max}
                          step={step || "1"}
                          value={form[key] != null && form[key] !== "" ? String(form[key]) : ""}
                          onChange={(e) =>
                            setForm((prev) => ({ ...prev, [key]: e.target.value }))
                          }
                        />
                        {suffix && <span className="input-group-text bg-white">{suffix}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-3">
                <button className="btn btn-primary btn-sm" onClick={handleSave}>
                  Зберегти
                </button>
              </div>
            </div>
          )}

          {activeTab === "uber" && (
            <>
              <p className="fw-bold mb-3">1. Завантажте Excel-файл з даними Uber</p>

              <div className="mb-4">
                <input
                  type="file"
                  className="form-control"
                  accept=".xlsx"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const reader = new FileReader();
                    reader.onload = (e) => {
                      const data = new Uint8Array(e.target.result);
                      const workbook = XLSX.read(data, { type: "array" });
                      const sheetName = workbook.SheetNames[0];
                      const sheet = workbook.Sheets[sheetName];
                      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                      const headers = jsonData[0] || [];
                      setExcelHeaders(headers);
                      setMessage(`✅ Файл завантажено. Виявлено ${headers.length} колонок`);
                      setMessageType("success");
                    };
                    reader.readAsArrayBuffer(file);
                  }}
                />
              </div>

              <p className="fw-bold mb-3">2. Вкажіть відповідність колонок Excel → полям у БД Uber:</p>

              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "50%" }}>Поле в БД</th>
                    <th style={{ width: "50%" }}>Назва в Excel</th>
                  </tr>
                </thead>
                <tbody>
                  {uberKeys.map((key) => (
                    <tr key={key}>
                      <td className="align-middle">{key}</td>
                      <td>
                        <Select
                          classNamePrefix="react-select"
                          placeholder="Оберіть або введіть"
                          isClearable
                          isSearchable
                          value={
                            form[`uber_${key}`]
                              ? { label: form[`uber_${key}`], value: form[`uber_${key}`] }
                              : null
                          }
                          onChange={(selectedOption) =>
                            setForm((prev) => ({
                              ...prev,
                              [`uber_${key}`]: selectedOption ? selectedOption.value : ""
                            }))
                          }
                          onInputChange={(inputValue) => {
                            if (inputValue && !excelHeaders.includes(inputValue)) {
                              addCustomOption(inputValue);
                            }
                          }}
                          onBlur={() => {
                            const current = form[`uber_${key}`];
                            if (current && !excelHeaders.includes(current)) {
                              addCustomOption(current);
                            }
                          }}
                          options={excelHeaders.map((header) => ({
                            label: header,
                            value: header
                          }))}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {uberKeys.every((key) => form[`uber_${key}`]?.trim?.() !== "") &&
                uberKeys.every((key) => excelHeaders.includes(form[`uber_${key}`])) && (
                  <div className="alert alert-success mt-3">
                    ✅ Усі значення відповідають стовпцям у Excel. Готово до збереження!
                  </div>
                )}

              {uberKeys.every((key) => form[`uber_${key}`]?.trim?.() !== "") &&
                !uberKeys.every((key) => excelHeaders.includes(form[`uber_${key}`])) && (
                  <div className="alert alert-warning mt-3">
                    ⚠️ Не всі назви з форми знайдено серед стовпців Excel. Перевірте уважно.
                  </div>
                )}

              <div className="d-flex gap-2 mt-3">
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={() => {
                    const cleared = {};
                    uberKeys.forEach((key) => {
                      cleared[`uber_${key}`] = "";
                    });
                    setForm((prev) => ({ ...prev, ...cleared }));
                  }}
                >
                  Очистити всі поля
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={!uberKeys.every((key) => form[`uber_${key}`]?.trim?.() !== "")}
                >
                  Зберегти
                </button>
              </div>
            </>
          )}


          {activeTab === "bolt" && (
            <>
              <p className="fw-bold mb-3">1. Завантажте Excel-файл з даними Bolt</p>

              <div className="mb-4">
                <input
                  type="file"
                  className="form-control"
                  accept=".xlsx"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const reader = new FileReader();
                    reader.onload = (e) => {
                      const data = new Uint8Array(e.target.result);
                      const workbook = XLSX.read(data, { type: "array" });
                      const sheetName = workbook.SheetNames[0];
                      const sheet = workbook.Sheets[sheetName];
                      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                      const headers = jsonData[0] || [];
                      setExcelHeaders(headers);
                      setMessage(`✅ Файл завантажено. Виявлено ${headers.length} колонок`);
                      setMessageType("success");
                    };
                    reader.readAsArrayBuffer(file);
                  }}
                />
              </div>

              <p className="fw-bold mb-3">2. Вкажіть відповідність колонок Excel → полям у БД Bolt:</p>

              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "50%" }}>Поле в БД</th>
                    <th style={{ width: "50%" }}>Назва в Excel</th>
                  </tr>
                </thead>
                <tbody>
                  {boltKeys.map((key) => (
                    <tr key={key}>
                      <td className="align-middle">{key}</td>
                      <td>
                        <Select
                          classNamePrefix="react-select"
                          placeholder="Оберіть або введіть"
                          isClearable
                          isSearchable
                          value={
                            form[`bolt_${key}`]
                              ? { label: form[`bolt_${key}`], value: form[`bolt_${key}`] }
                              : null
                          }
                          onChange={(selectedOption) =>
                            setForm((prev) => ({
                              ...prev,
                              [`bolt_${key}`]: selectedOption ? selectedOption.value : ""
                            }))
                          }
                          onInputChange={(inputValue) => {
                            if (inputValue && !excelHeaders.includes(inputValue)) {
                              addCustomOption(inputValue);
                            }
                          }}
                          onBlur={() => {
                            const current = form[`bolt_${key}`];
                            if (current && !excelHeaders.includes(current)) {
                              addCustomOption(current);
                            }
                          }}
                          options={excelHeaders.map((header) => ({
                            label: header,
                            value: header
                          }))}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {areAllBoltFieldsFilled && boltKeys.every((key) => excelHeaders.includes(form[`bolt_${key}`])) && (
                <div className="alert alert-success mt-3">
                  ✅ Усі значення відповідають стовпцям у Excel. Готово до збереження!
                </div>
              )}

              {areAllBoltFieldsFilled && !boltKeys.every((key) => excelHeaders.includes(form[`bolt_${key}`])) && (
                <div className="alert alert-warning mt-3">
                  ⚠️ Не всі назви з форми знайдено серед стовпців Excel. Перевірте уважно.
                </div>
              )}

              <div className="d-flex gap-2 mt-3">
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={handleClearBoltFields}
                >
                  Очистити всі поля
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={!areAllBoltFieldsFilled}
                >
                  Зберегти
                </button>
              </div>
            </>
          )}





          {activeTab === "freenow" && (
            <>
              <p className="fw-bold mb-3">1. Завантажте Excel-файл з даними FreeNow</p>

              <div className="mb-4">
                <input
                  type="file"
                  className="form-control"
                  accept=".xlsx"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const reader = new FileReader();
                    reader.onload = (e) => {
                      const data = new Uint8Array(e.target.result);
                      const workbook = XLSX.read(data, { type: "array" });
                      const sheetName = workbook.SheetNames[0];
                      const sheet = workbook.Sheets[sheetName];
                      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                      const headers = jsonData[0] || [];
                      setExcelHeaders(headers);
                      setMessage(`✅ Файл завантажено. Виявлено ${headers.length} колонок`);
                      setMessageType("success");
                    };
                    reader.readAsArrayBuffer(file);
                  }}
                />
              </div>

              <p className="fw-bold mb-3">2. Вкажіть відповідність колонок Excel → полям у БД FreeNow:</p>

              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "50%" }}>Поле в БД</th>
                    <th style={{ width: "50%" }}>Назва в Excel</th>
                  </tr>
                </thead>
                <tbody>
                  {freenowKeys.map((key) => (
                    <tr key={key}>
                      <td className="align-middle">{key}</td>
                      <td>
                        <Select
                          classNamePrefix="react-select"
                          placeholder="Оберіть або введіть"
                          isClearable
                          isSearchable
                          value={
                            form[`freenow_${key}`]
                              ? { label: form[`freenow_${key}`], value: form[`freenow_${key}`] }
                              : null
                          }
                          onChange={(selectedOption) =>
                            setForm((prev) => ({
                              ...prev,
                              [`freenow_${key}`]: selectedOption ? selectedOption.value : ""
                            }))
                          }
                          onInputChange={(inputValue) => {
                            if (inputValue && !excelHeaders.includes(inputValue)) {
                              addCustomOption(inputValue);
                            }
                          }}
                          onBlur={() => {
                            const current = form[`freenow_${key}`];
                            if (current && !excelHeaders.includes(current)) {
                              addCustomOption(current);
                            }
                          }}
                          options={excelHeaders.map((header) => ({
                            label: header,
                            value: header
                          }))}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {freenowKeys.every((key) => form[`freenow_${key}`]?.trim?.() !== "") &&
                freenowKeys.every((key) => excelHeaders.includes(form[`freenow_${key}`])) && (
                  <div className="alert alert-success mt-3">
                    ✅ Усі значення відповідають стовпцям у Excel. Готово до збереження!
                  </div>
                )}

              {freenowKeys.every((key) => form[`freenow_${key}`]?.trim?.() !== "") &&
                !freenowKeys.every((key) => excelHeaders.includes(form[`freenow_${key}`])) && (
                  <div className="alert alert-warning mt-3">
                    ⚠️ Не всі назви з форми знайдено серед стовпців Excel. Перевірте уважно.
                  </div>
                )}

              <div className="d-flex gap-2 mt-3">
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={() => {
                    const cleared = {};
                    freenowKeys.forEach((key) => {
                      cleared[`freenow_${key}`] = "";
                    });
                    setForm((prev) => ({ ...prev, ...cleared }));
                  }}
                >
                  Очистити всі поля
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={!freenowKeys.every((key) => form[`freenow_${key}`]?.trim?.() !== "")}
                >
                  Зберегти
                </button>
              </div>
            </>
          )}

          {activeTab === "months" && (
            <>
              <p className="fw-bold mb-3">Мапінг тижнів по місяцях</p>
              <p className="text-muted mb-4">
                Вкажіть, які тижні входять до кожного місяця для кожного року.
                Формат номера тижня: YYYYWW (наприклад, 202501 - перший тиждень 2025 року)
              </p>

              {!form.months || Object.keys(form.months).length === 0 ? (
                <div className="alert alert-info">
                  <p className="mb-2">Мапінг тижнів ще не налаштовано.</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      const currentYear = new Date().getFullYear().toString();
                      const nextYear = (new Date().getFullYear() + 1).toString();
                      
                      setForm((prev) => ({
                        ...prev,
                        months: {
                          [currentYear]: {},
                          [nextYear]: {}
                        }
                      }));
                    }}
                  >
                    Створити мапінг
                  </button>
                </div>
              ) : null}

              {form.months && Object.keys(form.months).length > 0 && Object.keys(form.months).sort((a, b) => Number(b) - Number(a)).map((year) => {
                const filledMonths = Object.keys(form.months[year] || {}).filter(
                  month => form.months[year][month]?.length > 0
                ).length;
                
                return (
                <div key={year} className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">{year} рік</h5>
                    <div className="d-flex gap-2 align-items-center">
                      <span className="badge bg-info">
                        Заповнено: {filledMonths} з 12 місяців
                      </span>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => {
                          if (window.confirm(`Ви впевнені, що хочете видалити мапінг для ${year} року?`)) {
                            const { [year]: removed, ...remainingYears } = form.months;
                            setForm((prev) => ({
                              ...prev,
                              months: remainingYears
                            }));
                            setMessage(`✅ Видалено мапінг для ${year} року`);
                            setMessageType("success");
                          }
                        }}
                      >
                        Видалити рік
                      </button>
                    </div>
                  </div>
                  <div className="row g-3">
                    {["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"].map((month) => {
                      const monthNames = [
                        "Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень",
                        "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"
                      ];
                      const monthName = monthNames[parseInt(month) - 1];

                      const hasWeeks = form.months[year]?.[month]?.length > 0;
                      
                      return (
                        <div key={month} className="col-md-6">
                          <div className={`card ${hasWeeks ? 'border-success' : ''}`}>
                            <div className="card-body">
                              <h6 className="card-title">
                                {monthName} ({month})
                                {hasWeeks && (
                                  <span className="badge bg-success ms-2">
                                    {form.months[year][month].length} тижнів
                                  </span>
                                )}
                              </h6>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="202501, 202502, 202503, 202504"
                                value={
                                  form.months[year]?.[month]
                                    ? form.months[year][month].join(", ")
                                    : ""
                                }
                                onChange={(e) => {
                                  const weeks = e.target.value
                                    .split(",")
                                    .map((w) => w.trim())
                                    .filter((w) => w);
                                  
                                  setForm((prev) => ({
                                    ...prev,
                                    months: {
                                      ...prev.months,
                                      [year]: {
                                        ...(prev.months?.[year] || {}),
                                        [month]: weeks
                                      }
                                    }
                                  }));
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                );
              })}

              {form.months && Object.keys(form.months).length > 0 && (
                <div className="d-flex gap-2 mt-4">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      const newYear = prompt("Введіть рік для додавання:");
                      if (newYear && /^\d{4}$/.test(newYear)) {
                        if (form.months[newYear]) {
                          setMessage("⚠️ Цей рік вже існує в мапінгу");
                          setMessageType("warning");
                        } else {
                          setForm((prev) => ({
                            ...prev,
                            months: {
                              ...prev.months,
                              [newYear]: {}
                            }
                          }));
                          setMessage(`✅ Додано рік ${newYear}`);
                          setMessageType("success");
                        }
                      }
                    }}
                  >
                    Додати рік
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={handleSave}
                  >
                    Зберегти мапінг
                  </button>
                </div>
              )}
            </>
          )}

        </div>
      </div>
    </div >
  );
};

export default SiteSettings;
